/**
 * Register Entities - Inicialización del entity registry
 *
 * @version 1.0
 * @module core/entity-registry
 *
 * @description
 * Registra todas las entidades de la aplicación al iniciar.
 * Este archivo debe ser importado en el punto de entrada de la app.
 */

import { registerEntity } from './registry';
import { treeEntityConfig } from '../modules/environmental/config/tree-entity.config';
import { fountainEntityConfig } from '../modules/environmental/config/fountain-entity.config';
import { containerEntityConfig } from '../modules/waste/config/container-entity.config';

/**
 * Registra todas las entidades de la aplicación
 *
 * @remarks
 * Llamar esta función al inicio de la aplicación para registrar
 * todas las configuraciones de entidades disponibles.
 *
 * @example
 * ```ts
 * // En main.tsx o App.tsx
 * import { registerAllEntities } from '@/core/entity-registry/register-entities';
 *
 * registerAllEntities();
 * ```
 */
export function registerAllEntities(): void {
  console.log('[EntityRegistry] Registrando todas las entidades...');

  // Módulo Environmental
  registerEntity(treeEntityConfig);
  registerEntity(fountainEntityConfig);

  // Módulo Waste
  registerEntity(containerEntityConfig);

  // TODO: Agregar más entidades aquí cuando se implementen
  // registerEntity(sunshadeEntityConfig);
  // registerEntity(parkEntityConfig);

  console.log('[EntityRegistry] ✓ Todas las entidades registradas');
}
